import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { OrderedMap } from 'immutable';
import cx from 'classnames';

import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import UserModel from 'models/user';

import { parkingPassLicenseEditDisabled } from 'lib/common/messages';
import LicensePlateModal from 'components/vehicles/modal/license-plate';

class LicensePlateSection extends React.Component {
  constructor(props) {
    super(props);

    this.renderLicensePlateModal = this.renderLicensePlateModal.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.showLicensePlateModal = this.showLicensePlateModal.bind(this);
    this.hideLicensePlateModal = this.hideLicensePlateModal.bind(this);
    this.passHasPlate = this.passHasPlate.bind(this);
    this.renderPlateText = this.renderPlateText.bind(this);
    this.plateClasses = this.plateClasses.bind(this);

    this.state = {
      scanCodeDismissed: false,
      showLicensePlateModal: false,
      guestPlate: null,
    };
  }

  submitForm(input) {
    const { parkingPass, addVehicle } = this.props;

    addVehicle({
      ...input,
      bookingId: parkingPass.id,
    });
    this.hideLicensePlateModal();
    this.setState({ guestPlate: input.plateNumber });
  }

  plateClasses() {
    const hasPlate = this.passHasPlate();
    const largeText = hasPlate && (this.renderPlateText().length <= 9);
    const { parkingPass } = this.props;

    return cx({
      'col-xs-10': !parkingPass.hasReachedEndTime,
      'col-xs-12': parkingPass.hasReachedEndTime,
      'col-print-12': true,
      'h5-sg': !largeText,
      'text-color-dark-slate': hasPlate,
      'h2-sg': largeText,
      'text-color-white': !hasPlate,
      'vertical-padding-top': !hasPlate,
    });
  }

  passHasPlate() {
    const { vehicles, parkingPass } = this.props;
    return !!(parkingPass.getVehicle(vehicles) || this.state.guestPlate);
  }

  showLicensePlateModal() {
    const { parkingPass, addMessage } = this.props;
    if(!parkingPass.hasReachedEndTime) {
      this.setState({ showLicensePlateModal: true });
    } else {
      addMessage(parkingPassLicenseEditDisabled)
    }
  }

  hideLicensePlateModal() {
    this.setState({ showLicensePlateModal: false });
  }

  renderPlateText() {
    const { vehicles, parkingPass } = this.props;
    const { guestPlate } = this.state;
    const vehicle = parkingPass.getVehicle(vehicles);

    if (vehicle) {
      return vehicle.get('plateNumber');
    }
    if (guestPlate) { return guestPlate; }

    return (<FormattedMessage
      id="parking-pass.enter-plate"
      defaultMessage="ENTER LICENSE PLATE"
    />);
  }

  renderLicensePlateModal() {
    if (!this.state.showLicensePlateModal) {
      return null;
    }
    return (
      <LicensePlateModal
        user={this.props.user}
        vehicles={this.props.vehicles}
        submitForm={this.submitForm}
        onClose={this.hideLicensePlateModal}
      />
    );
  }

  render() {
    const { parkingPass } = this.props;
    return (
      <div>
        <div className={`validation-box text-center row ${this.passHasPlate() ? null : 'missing-plate'}`} onClick={this.showLicensePlateModal}>
          <div className={this.plateClasses()}>
            { this.renderPlateText() }
          </div>
          {!parkingPass.hasReachedEndTime && <div className="col-xs-2 hidden-print">
            <span className="iconified iconified-pencil-circle float-right" />
          </div>}
        </div>
        {this.renderLicensePlateModal()}
      </div>
    );
  }
}

LicensePlateSection.propTypes = {
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
  vehicles: PropTypes.instanceOf(OrderedMap).isRequired,
  user: PropTypes.instanceOf(UserModel).isRequired,
  addMessage: PropTypes.func.isRequired,
  addVehicle: PropTypes.func.isRequired,
};

export default LicensePlateSection;
